export default {
	complete: "Complete",
	error: "Error saving. Please try again.",
	requiredHint: "Fields marked with * are required.",
	step1: {
		address: "Address",
		city: "City",
		cnpj: "CNPJ",
		razaoSocial: "Legal Name",
		state: "State",
		subtitle: "Basic information about your temple",
		title: "Temple Details",
		tradition: "Religious Tradition",
		whatsapp: "WhatsApp",
		zipCode: "Zip Code",
	},
	step2: {
		displayName: "Full Name",
		phone: "Phone",
		religiousName: "Religious Name",
		religiousNameHint: "E.g.: Pai João de Xangô",
		subtitle: "Your profile in the temple",
		title: "Your Details",
		userTitle: "Title/Role",
		userTitleHint: "E.g.: Babalorixá, Mãe de Santo, Leader",
		whatsappOptIn: "Receive ORI notices via WhatsApp",
		whatsappOptInHint:
			"Sent from ORI's official number to the phone above. You can turn this off at any time in your profile.",
	},
	step3: {
		logoUrl: "Logo URL",
		optional: "This step is optional. You can configure it later.",
		primaryColor: "Primary Color",
		subtitle: "Temple visual identity",
		title: "Customization",
	},
	step4: {
		title: "Plan",
		subtitle: "Confirm your plan",
		hint: "Review your chosen plan, apply a voucher if you have one, and complete your subscription.",
		confirmAndPay: "Confirm and pay",
		decideLater: "Decide later",
	},
	title: "Initial Setup",
};
